
















































import { Vue, Component } from 'vue-property-decorator';
import CustomButton from '@/components/Globals/CustomButton.vue';
import CustomContainer from '@/components/Globals/CustomContainer.vue';
import CustomModal from '@/components/Modals/wrapper/modalWrapper.vue';
import ModalHeader from '@/components/molecule.modal.header.vue';
import CustomText from "./Globals/CustomText.vue";

@Component({
  components: {
    CustomButton,
    CustomContainer,
    CustomModal,
    ModalHeader,
    CustomText
  },
})
export default class UgcPlacementWarning extends Vue {
  title: string = "";
  description: string = "";

  get translations() {
    return this.$store.state.translations.data;
  }

  get isApparel() {
    return this.$store.getters['utils/isApparelEnabled'];
  }

  beforeOpenModal(): void {
    this.title = this.isApparel ? this.translations.apparelPlacementWarningHeader : this.translations.placementWarningHeader;
    this.description = this.isApparel ? this.translations.apparelPlacementWarningDesc : this.translations.placementWarningDesc;
  }

  onContinue(): void {
    this.closeAction();
    this.$eventBus.$emit("placement-warning-continue");
  }

  closeAction(): void {
    this.$modal.hide("ugcPlacementWarningModal");
  }
}
